import { Component, ViewChild } from '@angular/core';
import { InfiniteScrollCustomEvent, IonSearchbar, ModalController } from '@ionic/angular';
import countries from '@shared/utilities/countries.json';

interface Country {
  nameES: string;
  nameEN: string;
  iso2: string;
  iso3: string;
  phoneCode: string;
}

@Component({
  selector: 'app-select-country',
  templateUrl: './select-country.component.html',
  styleUrl: './select-country.component.scss',
})
export class SelectCountryComponent {
  @ViewChild('searchBar') searchBar!: IonSearchbar;
  countries: Country[] = [];
  showCode = false;
  start = 0;
  end = 18;
  size = 18;

  constructor(private modalCtrl: ModalController) {
    this.countries = countries.sort((a, b) => {
      if (a.nameES < b.nameES) return -1;
      if (a.nameES > b.nameES) return 1;
      return 0;
    });
  }

  ionViewDidEnter() {
    this.searchBar.setFocus();
    this.start = 0;
    this.end = this.size;
  }

  close(c?: Country) {
    this.modalCtrl.dismiss(c ?? null, c ? 'save' : 'cancel');
  }

  onSearchChange(ev: CustomEvent) {
    this.start = 0;
    this.end = this.size;
    this.countries = countries
      .filter((c) => JSON.stringify(c).toLowerCase().includes(ev.detail.value.toLowerCase()))
      .sort((a, b) => {
        if (a.nameES < b.nameES) return -1;
        if (a.nameES > b.nameES) return 1;
        return 0;
      });
  }

  onIonInfinite(ev: InfiniteScrollCustomEvent) {
    this.end += this.size;

    ev.target.complete();
  }
}
